import React, { useEffect,useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import {ServicioFormatos } from '../../../servicios/ServicioFormatos';

export const TablaResultados = (props) => {

    const { resultados } = props;
    const dt = useRef(null);

    useEffect(() => {       
    }, [resultados]);

    const onIndexTemplate = (data, props) => {
        let inicio = 0;
        return (props.rowIndex + 1) + inicio;
    }

    const templateErrorResultado = (rowData, column) => {
        if (rowData.error)
            return <Button icon="pi pi-times" className="p-button-rounded p-button-danger" />;
        else
            return <Button icon="pi pi-check" className="p-button-rounded p-button-success" />;
    }

    const exportE = () => {
        dt.current.exportCSV();
    }



    const header = <div style={{textAlign:'left'}}><Button type="button" icon="pi pi-external-link" iconPos="left" label="Exportar Resultados" onClick={exportE}></Button></div>;


    const columnaFecha = (rowData, column) => {
        return ServicioFormatos.formatearFecha(rowData.fechaCreacion);
    }

    const columnaMoneda = (rowData, column) => {
        return ServicioFormatos.formatearModena(rowData.total);
    }

    return (
        <div className="grid table-demo">
            <div className="col-12">
                <div className="card">
                    <h5>Resultado de validación</h5>
                    <DataTable value={resultados} ref={dt} header={header}  className="p-datatable-gridlines" showGridlines
                       responsiveLayout="scroll" >
                        <Column header="No." body={onIndexTemplate} style={{ width: '40px' }} />
                        <Column header="Nombre Archivo" field="nombreLayout" />   
                        <Column field="uuid" header="UUID" />                     
                        <Column field="errores" header="Error" style={{ width: '60px' }} />
                        <Column field="codigoError" header="Código Error" />
                        <Column field="numeroEmpleado" header="Número Empleado" />
                        <Column field="nombreEmpleado" header="Rfc Receptor" />
                        <Column field="rfcEmpleado" header="Nombre Receptor" />                                                
                    </DataTable>
                </div>
            </div>
        </div>
    );
}